import React, { useState, useEffect } from 'react';
import { Input, Button, Select, SelectItem, Spinner } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { getOnlyNumbers, fromPhotos, Constants, fromAssets } from '../../../utils';
import { IconImageEdit } from '../../../assets/icons';
import { UsersService, AuthService } from '../../../services';
import CountryFlag from '../../../components/country-flag';

const SchoolSettings = () => {
  const {
    countries,
    form,
    isLoading,
    onChange,
    onChangeCountry,
    onChangeState,
    onUpload,
    onSubmit,
    phoneCodes,
    states,
    townships,
    documentTypes
  } = useForm();

  return (
    <div className="bg-white rounded-xl max-w-[60rem] m-auto p-10">
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}
      <div className="flex flex-col sm:flex-row justify-start gap-8 sm:gap-14">
        <label htmlFor="photo" className="flex-shrink-0 cursor-pointer text-center border-2 border-gray w-36 h-36 rounded-lg flex justify-center items-center self-center overflow-hidden">
          {!!form.photoUrl ? (
            <img className="w-full h-full object-cover" src={form.photoUrl} alt="Foto del colegio" />
          ) : (
            <img className="w-12 object-contain opacity-50" src={IconImageEdit} alt="Foto del colegio" />
          )}
          <input
            id="photo"
            type="file"
            accept="image/*"
            hidden
            onChange={onUpload}
          />
        </label>

        <div className='w-full flex flex-col justify-between gap-y-6 sm:gap-y-0'>
          <Input
            label="Nombre"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form.name}
            onValueChange={v => onChange(v, 'name')}
          />
          <div className='flex gap-6'>
            <Input
              label="Director(a)"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.director}
              onValueChange={v => onChange(v, 'director')}
            />
            <Input
              label="DNI/C.I"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Cédula del director"
                  variant="flat"
                  disabled={true}
                  classNames={{ trigger: 'border-0 max-w-24' }}
                  disallowEmptySelection={true}
                  selectedKeys={form.document_type_director ? [form.document_type_director] : ''}
                  onSelectionChange={v => onChange(v.currentKey, 'document_type_director')}
                >
                  {documentTypes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.document_director}
              onValueChange={v => onChange(v, 'document_director')}
            />
          </div>
        </div>
      </div>

      <div className="flex mt-6 flex-col flex-1 gap-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 gap-y-6">
          <Input
            label="Teléfono"
            labelPlacement="outside"
            placeholder=" "
            startContent={(
              <Select
                aria-label="Código de área"
                variant="flat"
                classNames={{ trigger: 'border-0 max-w-28' }}
                disallowEmptySelection={true}
                selectedKeys={(!!form.phonecode_id && !!phoneCodes.length) ? [form.phonecode_id] : []}
                onSelectionChange={v => onChange(v.currentKey, 'phonecode_id')}
                startContent={<CountryFlag phoneCodeId={form.phonecode_id} phoneCodes={phoneCodes} />}
              >
                {phoneCodes.map((item) => (
                  <SelectItem
                    key={item.value}
                    value={item.value}
                    startContent={<CountryFlag src={item.url} />}
                    classNames={{ title: 'min-w-48' }}
                  >
                    {item.label}
                  </SelectItem>
                ))}
              </Select>
            )}
            variant="bordered"
            radius="sm"
            classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
            value={form.phone}
            onValueChange={v => onChange(getOnlyNumbers(v), 'phone')}
          />
          <Input
            label="Correo electrónico"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form.email}
            onValueChange={v => onChange(v, 'email')}
          />
          <Input
            label="RIF/NIT"
            labelPlacement="outside"
            placeholder=" "
            // startContent={(
            //     <Select
            //         aria-label="RIF/NIT"
            //         variant="flat"
            //         classNames={{ trigger: 'border-0 max-w-24' }}
            //         disallowEmptySelection={true}
            //         selectedKeys={form.document_type_id ? [form.document_type_id] : ''}
            //         onSelectionChange={v => onChange(v.currentKey, 'document_type_id')}
            //     >
            //         {documentTypes.map((item) => (
            //             <SelectItem key={item.value} value={item.value}>
            //                 {item.label}
            //             </SelectItem>
            //         ))}
            //     </Select>
            // )}
            variant="bordered"
            radius="sm"
            classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
            value={form.document}
            onValueChange={v => onChange(v, 'document')}
          />
          {/* --- Select País aquí --- */}
          <Select
            label="País"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.country_id ? [form.country_id] : []}
            onSelectionChange={onChangeCountry}
          >
            {countries.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </Select>
          <Select
            label={!form.country_id ? 'Estado/Departamento' : form.country_id === '1' ? 'Estado' : 'Departamento'}
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.state_id ? [form.state_id] : []}
            onSelectionChange={onChangeState}
            isDisabled={!form.country_id}
          >
            {states.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </Select>
          <Select
            label="Municipio"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.municipality_id ? [form.municipality_id] : []}
            onSelectionChange={v => onChange(v.currentKey, 'municipality_id')}
            isDisabled={!form.state_id}
          >
            {townships.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </Select>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 sm:gap-4 gap-y-6">
          <Input
            label="Dirección"
            labelPlacement="outside"
            className="col-span-2"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form.address}
            onValueChange={v => onChange(v, 'address')}
          />

          <Input
            label="Zona educativa"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            value={form.educational_center}
            onValueChange={v => onChange(v, 'educational_center')}
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 sm:gap-4 gap-y-6">
          <Input
            label="Código DEA"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form.dea_code}
            onValueChange={v => onChange(v, 'dea_code')}
          />

          <Input
            label="Coordinador(a) de CE"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            value={form.coordinator}
            onValueChange={v => onChange(v, 'coordinator')}
          />

          <Input
            label="DNI/C.I"
            labelPlacement="outside"
            placeholder=" "
            startContent={(
              <Select
                aria-label="Cédula del Coordinador"
                variant="flat"
                disabled={true}
                classNames={{ trigger: 'border-0 max-w-24' }}
                disallowEmptySelection={true}
                selectedKeys={form.document_type_coordinator ? [form.document_type_coordinator] : ''}
                onSelectionChange={v => onChange(v.currentKey, 'document_type_coordinator')}
              >
                {documentTypes.map((item) => (
                  <SelectItem key={item.value} value={item.value}>
                    {item.label}
                  </SelectItem>
                ))}
              </Select>
            )}
            variant="bordered"
            radius="sm"
            classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
            value={form.document_coordinator}
            onValueChange={v => onChange(v, 'document_coordinator')}
          />
        </div>

        <div className="flex flex-col items-center" >
          <Button
            type="button"
            className="w-1/4 bg-green text-white text-md"
            onClick={() => onSubmit()}
            isLoading={isLoading}
            isDisabled={isLoading}
          >
            Guardar
          </Button>
        </div>
      </div>
    </div>
  )
}

// Hook useForm adaptado para edición y selección dinámica de país
const useForm = () => {
  const initialForm = {
    id: null,
    level_id: Constants.USER.LEVELS.SCHOOL,
    photo: {},
    photoUrl: '',
    school_id: '',
    name: '',
    director: '',
    phonecode_id: '',
    document_director: '',
    phone: '',
    email: '',
    country_id: '',
    document_type_id: '',
    document_type_coordinator: '',
    document_type_director: '',
    document: '',
    state_id: '',
    municipality_id: '',
    address: '',
    educational_center: '',
    dea_code: '',
    coordinator: '',
    document_coordinator: '',
    hasFile: true,
  };
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [states, setStates] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [townships, setTownships] = useState([]);

  const onChange = (value, target) => {
    if (target === 'photo' && !!value) {
      setForm(s => ({ ...s, photoUrl: URL.createObjectURL(value) }));
    }
    setForm(s => ({ ...s, [target]: value }));
  };

  const onUpload = (e) => {
    onChange(e.target.files[0], 'photo');
  };

  // Select de país, recarga estados y municipios
  const onChangeCountry = async (selected) => {
    const country_id = selected.currentKey;
    setForm(s => ({
      ...s,
      country_id,
      state_id: '',
      municipality_id: '',
    }));
    setStates([]); setTownships([]);
    if (country_id) {
      await getStatesByCountry(country_id);
    }
  };

  // Select de estado, recarga municipios
  const onChangeState = async (selected) => {
    const state_id = selected.currentKey;
    setForm(s => ({
      ...s,
      state_id,
      municipality_id: ''
    }));
    setTownships([]);
    if (state_id) {
      await getMunicipalitiesByState(state_id);
    }
  };

  const onError = (msg) => {
    toast.error(msg);
    return false;
  };

  const isValidForm = () => {
    if (!form.name)
      return onError('Debe indicar el nombre del colegio');
    if (!form.director)
      return onError('Debe indicar el nombre del director');
    if (!form.phonecode_id)
      return onError('Debe indicar el código de área');
    if (!form.phone)
      return onError('Debe indicar el número telefónico');
    if (!form.document_director)
      return onError('Debe indicar la cédula del director');
    if (!form.document)
      return onError('Debe indicar el rif');
    if (!form.email)
      return onError('Debe indicar el correo');
    if (!form.email.match(/^[A-Za-z0-9._%+-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,}$/))
      return onError('El correo debe tener un formato válido');
    if (!form.country_id)
      return onError('Debe indicar el país');
    if (!form.state_id)
      return onError('Debe indicar el estado');
    if (!form.municipality_id)
      return onError('Debe indicar el municipio');
    if (!form.address)
      return onError('Debe indicar la dirección');
    if (!form.educational_center)
      return onError('Debe indicar la zona educativa');
    return true
  };

  const onSubmit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);
    try {
      const userUpdated = await UsersService.school.update(form);
      dispatch({ type: 'SET_USER', payload: userUpdated });
      toast.success('Datos actualizados correctamente');
    } catch (error) {
      onError(String(error));
    } finally {
      setIsLoading(false);
    }
  };

  const getSelects = async () => {
    const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));
    try {
      const selects = await AuthService.getSelects();
      setCountries(toSelect(selects.countries));
      setPhoneCodes(toSelect(selects.phonecodes));
      setDocumentTypes(toSelect(selects.document_types));
    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
    }
  };

  const getStatesByCountry = async (country_id) => {
    setIsLoading(true);
    try {
      const { states } = await AuthService.getStates({ country_id });
      setStates(states.map(x => ({ ...x, value: String(x.id), label: x.name })));
    } catch (error) {
      toast.error('Error al obtener los estados');
    }
    setIsLoading(false);
  };

  const getMunicipalitiesByState = async (state_id) => {
    setIsLoading(true);
    try {
      const { municipalities } = await AuthService.getMunicipalities({ state_id });
      setTownships(municipalities.map(x => ({ ...x, value: String(x.id), label: x.name })));
    } catch (error) {
      toast.error('Error al obtener los municipios');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSelects();
  }, []);

  // Carga los valores guardados al cargar el usuario, y los estados/municipios relacionados
  useEffect(() => {
    if (!user) return;
    setForm(f => ({
      ...f,
      id: user?.id,
      photoUrl: !!user?.photo ? fromPhotos(user.photo) : '',
      school_id: user?.id,
      name: user?.name || '',
      director: user?.director || '',
      phonecode_id: String(user?.phonecode_id || ''),
      phone: user?.phone || '',
      email: user?.email || '',
      country_id: String(user?.country_id || ''),
      state_id: String(user?.state_id || ''),
      municipality_id: String(user?.municipality_id || ''),
      address: user?.address || '',
      educational_center: user?.educational_center || '',
      document: user?.document || '',
      document_coordinator: user?.document_coordinator || '',
      document_director: user?.document_director || '',
      coordinator: user?.coordinator || '',
      dea_code: user?.dea_code || '',
      document_type_id: user?.document_type_id
        ? String(user.document_type_id)
        : (String(user?.country_id) === '1' ? '1' : '2'),
      document_type_director: user?.document_type_director ? String(user.document_type_director) : '',
      document_type_coordinator: user?.document_type_coordinator ? String(user.document_type_coordinator) : '',
      hasFile: true
    }));
    // Recarga selects dependientes
    if (user?.country_id) getStatesByCountry(String(user.country_id));
    if (user?.state_id) getMunicipalitiesByState(String(user.state_id));
  }, [user]);

  return {
    countries,
    form,
    isLoading,
    onChange,
    onChangeCountry,
    onChangeState,
    onUpload,
    onSubmit,
    phoneCodes,
    states,
    townships,
    documentTypes,
  }
}

export default SchoolSettings;